import React from 'react';
import _ from 'lodash';
import Link from 'next/link';
import { Locale } from 'src/modules/locale';
import { useRouter } from 'next/router';
import styles from './FlagWithLocale.module.scss';
import classnames from 'classnames';
import { getOutputChannel } from 'src/modules/locale/components/Provider/outputChannel';

import UK from '../../../../../../public/images/flags/UK.svg';
import US from '../../../../../../public/images/flags/US.svg';
import AU from '../../../../../../public/images/flags/AU.svg';
import DE from '../../../../../../public/images/flags/DE.svg';

export type FlagWithLocaleFlagType = 'EN' | 'US' | 'AU' | 'DE';

const flags: Record<FlagWithLocaleFlagType, any> = {
  EN: UK,
  US,
  AU,
  DE,
};

export interface FlagWithLocaleProps {
  selected?: boolean;
  flag: FlagWithLocaleFlagType;
  label: string;
  locale?: Locale;
  href?: string;
  as?: string;
  shallow?: boolean;
  className?: string;
  onClick?: () => void;
}

const LinkWrapper = ({ href, locale, shallow, children }) => {
  if (href) {
    return (
      <Link href={href} locale={locale} scroll={false} shallow={shallow}>
        {children}
      </Link>
    );
  }

  return children;
};

export const FlagWithLocale = ({
  className,
  selected = false,
  flag,
  label,
  locale,
  shallow = false,
  href: _href,
  onClick = _.noop,
}: FlagWithLocaleProps) => {
  const router = useRouter();
  const FlagNode = flags[flag];

  const href = (() => {
    // within DE sites we go to localized version of the current page
    if (getOutputChannel() === 'de_DE' && _.includes(['DE', 'EN'], flag)) return router.asPath;

    // from DE to US, US to AU, etc. we navigate to the home page
    return _href;
  })();

  return (
    <LinkWrapper href={href} locale={locale} shallow={shallow}>
      <div
        className={classnames(className, styles.container, selected && styles.selected)}
        onClick={onClick}>
        <>
          <FlagNode className={styles.flag} />
          <span className={styles.label}>{label}</span>
        </>
      </div>
    </LinkWrapper>
  );
};
